import get from 'lodash/get';
export default (function (error) {
  return get(error, 'request.status') <= 0;
});